import React, { useEffect, useState } from 'react'
import { 
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle, 
  makeStyles, 
  Typography, 
  Grid,
  IconButton,
  Tooltip
} from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error';
import { negativeB, negativeC, positiveB, positiveC, primaryB, yellow } from 'asterX-UIkit/constants/colors';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DoneIcon from '@material-ui/icons/Done';
import jwtDecode from 'jwt-decode';

const useStyles = makeStyles(theme => ({
  root:{
    zIndex: '15000 !important',
    overflowX: 'hidden',
    overflowY: 'hidden',
    '& .MuiBackdrop-root': {
      backdropFilter: 'blur(16px)',
      transition: 'none !important',
      backgroundColor: 'rgba(0, 0, 0, 0.6) !important'
    }
  },
  paper: {
    borderRadius: 16,
  },
  button: {
    borderRadius: 8,
    border: '1px solid ' + primaryB,
    margin: '4px 8px',
    fontWeight: 600
  },
  copy: {
    borderRadius: 8,
    margin: '4px 8px',
    textTransform: 'none',
    fontWeight: 600
  },
  paste: {
    borderRadius: 8,
    color: positiveC,
    backgroundColor: positiveB,
    margin: '4px 8px',
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: positiveB
    },
  },
  iconE: {
    color: negativeC, 
    position: 'absolute', 
    height: 32, 
    width: 32, 
    right: 8, 
    top: 8
  },
  iconS: {
    color: yellow, 
    position: 'absolute', 
    height: 32, 
    width: 32, 
    right: 8, 
    top: 8
  },
  sub: {
    color: '#aaa',
    fontWeight: 600, 
    marginLeft: 4, 
    marginBottom: 4
  }, 
  textArea: {
    backgroundColor: negativeB, 
    borderRadius: 8, 
    padding: '8px 24px !important', 
    border: '1px solid #aaa'
  }
}))

const ErrorModal = ({e, close, snackbar}) => {
  const classes = useStyles()
  const [text, setText] = useState('')
  const [isCopy, setIsCopy] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(text)
    setIsCopy(true)
  }
  const handleClose = () => {
    setIsCopy(false)
    close()
  }

  useEffect(() => {
    if (!snackbar) {
      let builder = ''
      
      if(!!localStorage.getItem('token')) {
        builder += 'Username:\n' + jwtDecode(localStorage.getItem('token'))?.sub + '\n\n'
      }
      if(!!e?.config?.url) {
        builder += 'URL:\n' + e?.config?.url + '\n\n'
      }
      if(!!e?.response?.data) {
        builder += 'Response:\n' + Object.keys(e?.response?.data)?.map(i => 
        `${i}: ${e?.response?.data?.[i]}`
        )?.join('\n') + '\n\n'
      }
      if(!!e?.response?.headers) {
        builder += 'Headers:\n' + Object.keys(e?.response?.headers)?.map(i => 
        `${i}: ${e?.headers?.[i]}`
        )?.join('\n') + '\n\n'
      }
      if(!!e?.config?.data) {
        builder += 'RequestDataJSON:\n' + e?.config?.data + '\n\n'
      }
      if(!!localStorage) {
        builder += 'LocalStorage:\n' + Object.keys(localStorage)?.map(i => 
        `${i}: ${localStorage?.[i]}`
        )?.join('\n')
      }
      setText(builder)
    }
  }, [e])

  return (
    <>
      <Dialog
        open={e}
        classes={{paper: classes.paper, root: classes.root}}
      >
      <ErrorIcon classes={{root: !!snackbar ? classes.iconS : classes.iconE}} />
        <DialogTitle>
          <Typography variant={'h5'} style={{fontWeight: 600}}>
            {!!snackbar ? 'Внимание' : 'Ошибка'}
          </Typography>
        </DialogTitle>
        <DialogContent style={{ paddingLeft: 24, paddingRight: 24 }}>
          {!snackbar ?
            <>
              <Typography classes={{root: classes.sub}}>
                Отправьте данные из этого окна разработчикам:
              </Typography>
              <Grid classes={{root: classes.textArea}}>
              {!!localStorage.getItem('token') && 
                  <> 
                    <Typography style={{color: negativeC, fontWeight: 600, marginLeft: -8}}>
                      Username:
                    </Typography>
                    {jwtDecode(localStorage.getItem('token'))?.sub}
                  </>
                }
                {!!e?.config?.url && 
                  <> 
                    <Typography style={{color: negativeC, fontWeight: 600, marginLeft: -8}}>
                      URL:
                    </Typography>
                    <Typography style={{wordWrap: 'break-word', fontSize: 15, fontWeight: 500}}>
                      {e?.config?.url}
                    </Typography>
                  </>
                }
                {!!e?.response?.data && 
                  <> 
                    <Typography style={{color: negativeC, fontWeight: 600, marginLeft: -8}}>
                      Response:
                    </Typography>
                    {Object.keys(e?.response?.data)?.map(i => 
                      <Grid container direction={'row'}>
                        <Typography style={{fontWeight: 600, marginLeft: -4, marginRight: 4}}>
                          {i}:
                        </Typography>
                        <Typography style={{fontSize: 15, fontWeight: 500}}>
                          {e?.response?.data?.[i]}
                        </Typography>
                      </Grid>
                    )}
                  </>
                }
                {!!e?.response?.headers && 
                  <> 
                    <Typography style={{color: negativeC, fontWeight: 600, marginLeft: -8}}>
                      Headers:
                    </Typography>
                    {Object.keys(e?.response?.headers)?.map(i => 
                      <Grid container direction={'row'}>
                        <Typography style={{fontWeight: 600, marginLeft: -4, marginRight: 4}}>
                          {i}:
                        </Typography>
                        <Typography style={{fontSize: 15, fontWeight: 500}}>
                          {e?.response?.headers?.[i]}
                        </Typography>
                      </Grid>
                    )}
                  </>
                }
                {!!e?.config?.data && 
                  <> 
                    <Typography style={{color: negativeC, fontWeight: 600, marginLeft: -8}}>
                      RequestDataJSON:
                    </Typography>
                    <Typography style={{wordWrap: 'break-word', fontSize: 15, fontWeight: 500}}>
                      {JSON.stringify(e?.config?.data)}
                    </Typography>
                  </>
                }
                {!!localStorage && 
                  <> 
                    <Typography style={{color: negativeC, fontWeight: 600, marginLeft: -8}}>
                      LocalStorage:
                    </Typography>
                    {Object.keys(localStorage)?.map(i => 
                      <>
                        <Typography style={{fontWeight: 600, marginLeft: -4}}>
                          {i}:
                        </Typography>
                        <Typography style={{wordWrap: 'break-word', fontSize: 15, fontWeight: 500}}>
                          {localStorage?.[i]}
                        </Typography>
                      </>
                    )}
                  </>
                }
              </Grid>
            </>
            :
            <Typography style={{fontWeight: 600, fontSize: 20, padding: '0px 8px'}}>
              {e}
            </Typography>
          }
        </DialogContent>
        <DialogActions>
          <Grid container direction={'row'} justify={'space-between'} alignItems={'space-between'}>
            <Grid item>
              {!snackbar &&
                <Button onClick={handleCopy} classes={{root: isCopy ? classes.paste : classes.copy}}>
                  <>
                    {!!isCopy ?
                      <>
                        <DoneIcon style={{marginRight: 4}}/>
                        Скопировано
                      </>
                      :
                      <>
                        <FileCopyOutlinedIcon style={{marginRight: 4}}/>
                        Копировать
                      </>
                    }
                  </>
                </Button>
              }
            </Grid>
            <Grid item>
              <Button color={'primary'} onClick={handleClose} classes={{root: classes.button}}>
              <Typography style={{fontWeight: 600}}>
                ОК
              </Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ErrorModal
